const crypto = require('crypto')

const algorithm = process.env.VUE_APP_CRYPTO_ALGORITHM
const secretKey = process.env.VUE_APP_CRYPTO_KEY
const iv = process.env.VUE_APP_CRYPTO_IV

const encrypt = (text) => {
  const cipher = crypto.createCipheriv(algorithm, secretKey, iv)
  const encrypted = Buffer.concat([cipher.update(text), cipher.final()])
  return encrypted.toString('hex')
}

const decrypt = (hash) => {
  const decipher = crypto.createDecipheriv(algorithm, secretKey, iv)
  const decrpyted = Buffer.concat([
    decipher.update(Buffer.from(hash, 'hex')),
    decipher.final()
  ])
  return decrpyted.toString()
}

export default {
  encrypt,
  decrypt
}
